module.exports = __webpack_public_path__ + "img/icon_map_7_off_010.2156d791.png";